import { render, staticRenderFns } from "./menuLeft.vue?vue&type=template&id=54a62fe8&scoped=true"
import script from "./menuLeft.vue?vue&type=script&lang=js"
export * from "./menuLeft.vue?vue&type=script&lang=js"
import style0 from "./menuLeft.vue?vue&type=style&index=0&id=54a62fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a62fe8",
  null
  
)

export default component.exports